var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('center',[_c('img',{attrs:{"src":require("@/assets/logo3.png"),"alt":"adminicon","id":"image"}}),_vm._v(" "),_c('br'),_vm._v("¡Bievenido al Panel de Administración!")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d8750a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Header.vue
// module id = 643
// module chunks = 2